var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"loader-transition","appear":""}},[_c('div',{staticClass:"o-loader"},[_c('div',{staticClass:"o-loader__ring"},[_c('div'),_c('div'),_c('div'),_c('div')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }